import { VEHICLE_TYPE as VEHICLE_TYPE_FIELD } from "./";
import { ALL } from "../strings";

const DEFAULT_VALUE = {
  value: "0",
  label: ALL,
  functionParameters: { value: "0", label: ALL },
};

export const VEHICLE_TYPE = {
  title: "Vehicle Type",
  field: VEHICLE_TYPE_FIELD,
  mapToValues: (vehicles) => {
    const options = Object.values(vehicles || {}).map(
      ({ code, description }) => {
        const value = {
          value: code,
          label: description || code,
        };
        return {
          ...value,
          functionParameters: { field: "code", value: code },
        };
      }
    );
    options.sort((a, b) => a.label.localeCompare(b.label));
    return [DEFAULT_VALUE, ...options];
  },
  filterCallback: ({ vehicle, field, value }) => vehicle?.[field] === value,
  volumeOverlayRequired: false,
};
